import { i18n, resources } from '@tickitacka/shared';

// main-app에 필요한 네임스페이스 설정
// 기본 i18n 설정은 shared 패키지에서 제공
if (i18n.isInitialized) {
    // 모든 필요한 네임스페이스 추가
    const namespaces = [
        'common',
        'task',
        'project',
        'team',
        'todo',
        'report',
        'comment',
        'note',
        'activity',
        'landing',
        'landing_new',
        'ai',
        'notification',
        'auth',
    ];

    // 모든 언어와 네임스페이스에 대해 리소스 추가
    const languages = ['ko-KR', 'en-US', 'vi-VN'];

    languages.forEach(lang => {
        namespaces.forEach(ns => {
            const langResources = resources[lang] as Record<
                string,
                Record<string, unknown>
            >;
            if (langResources?.[ns]) {
                i18n.addResourceBundle(lang, ns, langResources[ns], true, true);
            }
        });
    });
}

export default i18n;
